import { useState, useEffect, useRef } from 'react';

export const CarouselComponent = ({ elements = [], switchTime, onBannerClick, authToken }) => {
    const [activeIndex, setActiveIndex] = useState(0);
    const [progress, setProgress] = useState(0);
    const [animationKey, setAnimationKey] = useState(0);
    const animationFrameRef = useRef(null);
    const startTimeRef = useRef(null);


    const [imageUrls, setImageUrls] = useState({}); // klucz: imageName, wartość: URL do Bloba

    // 👇 Preload image blobs
    useEffect(() => {
        let revokedUrls = [];
        const loadImages = async () => {
            const newImageUrls = {};

            await Promise.all(elements.map(async (el) => {
                if (!imageUrls[el.imageName]) {
                    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/start-page/get-banner-image/${el.imageName}?token=${authToken}`);
                    const blob = await response.blob();
                    const url = URL.createObjectURL(blob);
                    newImageUrls[el.imageName] = url;
                    revokedUrls.push(url);
                }
            }));

            setImageUrls(prev => ({ ...prev, ...newImageUrls }));
        };

        if (elements.length) {
            loadImages();
        }
        return () => {
            console.log("Component will unmount");
            revokedUrls.forEach(url => {
                URL.revokeObjectURL(url);
            });
        };
    }, [elements, authToken]);


    useEffect(() => {
        if (elements.length <= 1) {
            setProgress(0);
            return;
        }

        startTimeRef.current = null;
        setProgress(0);

        const animate = (time) => {
            if (!startTimeRef.current) startTimeRef.current = time;
            const elapsed = time - startTimeRef.current;
            const percentage = Math.min((elapsed / switchTime) * 100, 100);
            setProgress(percentage);

            if (percentage < 100) {
                animationFrameRef.current = requestAnimationFrame(animate);
            } else {
                setActiveIndex((i) => (i + 1) % elements.length);
                startTimeRef.current = null;
                setProgress(0);
                animationFrameRef.current = requestAnimationFrame(animate);
            }
        };

        animationFrameRef.current = requestAnimationFrame(animate);

        return () => {
            if (animationFrameRef.current) cancelAnimationFrame(animationFrameRef.current);
        };
    }, [elements, switchTime, activeIndex, animationKey]);

    const onDotClick = (index) => {
        if (animationFrameRef.current) cancelAnimationFrame(animationFrameRef.current);
        setActiveIndex(index);
        setProgress(0);
        setAnimationKey((prev) => prev + 1);  // wymusza restart animacji
    };

    if (elements.length === 0) return null;
    const currentElement = elements[activeIndex];
    const imageSrc = imageUrls[currentElement.imageName];

    const fullUrl = currentElement.url?.startsWith('http')
    ? currentElement.url 
    : `https://${currentElement.url}`;

    return (
        <div className="carousel-wrapper">
            <a
                href={fullUrl}
                title={elements[activeIndex].title}
                target="_blank"
                rel="noreferrer"
                onClick={() => onBannerClick && onBannerClick(elements[activeIndex], activeIndex)}
            >
                <img
                    // src={`${process.env.REACT_APP_BACKEND_URL}/start-page/get-banner-image/${elements[activeIndex].imageName}`+ '?token=' + authToken} //odpytuje backend za kazdym razem
                    src={imageSrc}
                    alt={`banner-${activeIndex}`}
                    className="carousel-image"
                />
            </a>
            <div className="pagination">
                {elements.length > 1 ? elements.map((_, index) => {
                    const isActive = index === activeIndex;
                    return (
                        <div
                            key={index}
                            onClick={() => onDotClick(index)}
                            className="pagination-bar"
                        >
                            {isActive && (
                                <div
                                    className="pagination-bar-fill"
                                    style={{ width: `${progress}%`, transition: 'width 0.1s linear' }}
                                />
                            )}
                        </div>
                    );
                }) : null}
            </div>
        </div>
    );
};